import store from "@/store"

class Multicast {
  constructor() {
    this.multicast = true
    this.init = false
  }
  async _init() {
    if (this.init) return true

    _$.vue.$on("mediaEnded", async () => {
      if (!__.media.getLoop()) return false
      if (__.platform.hasBackground()) __.platform.background(store.state.background.slides, __.media.getSource())
      else __.media.play(__.media.getSource(), true)
    })

    this.init = true
    return true
  }

  async start() {
    __.common._tvWindowSetSize()
    return true
  }
  async destroy() {
    this.stop()
    playmore.media.playerBehind()
    return true
  }
  async play() {
    if (document.getElementById("videoplane")) document.getElementById("videoplane").style.display = "none"
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      if (e.type === "mediaError") {
        promise.reject()
      } else promise.resolve()
    })

    /* Library Code */
    playmore.media.play(__.media.getSource())
    /* Library Code */

    return promise.done
  }
  async stop() {
    if (!["playing"].includes(__.media.status)) return playmore.media.stop()

    let promise = await _$.progress.create()
    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    playmore.media.stop()
    /* Library Code */

    return promise.done
  }
  async pause() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPaused", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    /* Library Code */
    playmore.media.pause()
    /* Library Code */

    return promise.done
  }
  async continue() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    /* Library Code */
    playmore.media.play()
    /* Library Code */

    return promise.done
  }

  /* Control Helpers */
  async isSeekable() {
    return playmore.media.isSeekable()
  }
  async getDuration() {
    return playmore.media.getDuration()
  }
  async getPosition() {
    return playmore.media.getPosition()
  }
  async setPosition(second) {
    if (!playmore.media.isSeekable()) return false
    const res = playmore.media.setPosition(second)
    if (res) _$.handler.emit({ type: "mediaEvent", detail: { state: "playing" } })
    return res
  }

  /* Language and Subtitles Helpers */
  async getSubtitles() {
    /* Library Code */
    let subtitles = JSON.parse(playmore.media.getSubtitles()),
      hasCurrent = subtitles.find(subtitle => subtitle.current)
    /* Library Code */

    subtitles = subtitles.map(subtitle => {
      return { key: subtitle.pid, value: subtitle.title, selected: subtitle.current }
    })

    if (!subtitles.length) return false
    else subtitles.unshift({ key: "off", value: "None", selected: !hasCurrent })

    return subtitles
  }
  async setSubtitle(pid) {
    if (pid === "off") pid = -1
    return playmore.media.setSubtitle(pid)
  }
  async closeSubtitle() {
    return playmore.media.setSubtitle(-1)
  }

  async getLanguages() {
    /* Library Code */
    let audios = JSON.parse(playmore.media.getAudios())
    /* Library Code */

    audios = audios.map(audio => {
      return { key: audio.pid, value: audio.title, selected: audio.current }
    })

    if (audios.length <= 1) return false
    return audios
  }
  async setLanguage(pid) {
    if (!pid) pid = -1
    return playmore.media.setAudio(pid)
  }
}

export default Multicast
